import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent, DataBindingDirective } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { GridSettings, Info } from '../../../../../core/common';
import { ProductSampleFulfillmentService } from '../../../../../core/services/product-sample-fulfillment.service';
import { UserService } from '../../../../../core/services/user.service';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotifyType } from '../../../../../core/enums/NotifyType';
import { AppNotifyService } from '../../../../../core/services/app-notify.service';
import { formatDate } from '@angular/common';
import { CommonService } from '../../../../../core/services/common.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as Excel from 'exceljs/dist/exceljs.min.js';
import * as ExcelProper from "exceljs";
import * as fs from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as _ from "lodash";
import { ISampleAdminBudgetAllocation } from '../../../../../core/models';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-allocation-report',
  templateUrl: './allocation-report.component.html',
  styleUrls: ['./allocation-report.component.scss']
})
export class AllocationReportComponent implements OnInit {
  AllocationReportHeaderGridData: GridDataResult;
  totalAllocationReportGridData: any[] = [];
  AllocationReportGridData: any[] = [];
  AllocationReportLoading: boolean;
  loadingPDF: boolean;
  loadingExcel: boolean;
  isonlyAllocationReport: boolean;
  isInActiveAllocationReport: boolean;
  filterSaveInProcess: boolean;
  IsAddNewAllocation: boolean;
  AddNewAllocationInProgress: false;
  isNewLocationComplete: boolean;
  isNewLocationSuccess: boolean;
  protected AllocationReportLblText = {
    regcodelbl: 'Reg Code',
    regdesclbl: 'Reg Description',
    budgetcodelbl: 'Budget Code',
    exportToExcelLbl: 'Export To Excel',
    exportToPDFLbl: 'Export To PDF',
    sampleProductLbl: 'Sample Request Allocation Report',
    addnewallocationlbl: 'Add New Allocation',
    regcodewarnlbl: 'Invalid RegCode',
    regdescwarnlbl: 'Invalid Reg Desc',
    budgetcodewarnlbl: 'Invalid Budget Code',
    saveLbl: 'Save',
    addNewLocationResponse: 'New location created successfully'
  };

  addNewAllocationV: ISampleAdminBudgetAllocation = {
    regionCode: '',
    regionDescription: '',
    budgetCode: ''
  };
  constructor(private formBuilder: FormBuilder, private router: Router,
    private userService: UserService, private productSampleFulfillmentService: ProductSampleFulfillmentService,
    private appNotifyService: AppNotifyService, private commonService: CommonService, private fb: FormBuilder
  ) { }
  AllocationForm = this.fb.group({
    regCode: ['', [Validators.required]],
    regDesc: ['', [Validators.required]],
    budgetCode: ['', [Validators.required]]
  });
  ngOnInit() {
    this.getAllAllocationReportReport();
  }
  public AllocationReportGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'regionCode',
      dir: 'asc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public AllocationReportGridSettings: GridSettings = {
    state: this.AllocationReportGridstate,
    gridData: process(this.AllocationReportGridData, this.AllocationReportGridstate),
    columnsConfig: [{
      field: 'regionCode',
      title: 'Reg Code',
      filterable: true,
      widthForPDF: 40,
      _width: 110,
    },
    {
      field: 'regionDescription',
      title: 'Reg Desc',
      filterable: true,
      widthForPDF: 60,
      _width: 130,
    },
    {
      field: 'budgetCode',
      title: 'Budget Code',
      filterable: true,
      widthForPDF: 40,
      _width: 110,
    }
    ]
  };
  filterOnlyAllocationReportItems(event) {
    if (event.target.checked)
      this.isonlyAllocationReport = true;
    else
      this.isonlyAllocationReport = false;
    this.getFilterAllocationReportItems();
  }
  filterInActiveAllocationReportItems(event) {
    if (event.target.checked)
      this.isInActiveAllocationReport = true;
    else
      this.isInActiveAllocationReport = false;
    this.getFilterAllocationReportItems();
  }
  getFilterAllocationReportItems() {
    let totalAllocationReportItems: any[] = [];
    if (this.isonlyAllocationReport && this.isInActiveAllocationReport) {
      for (const [key, value] of Object.entries(this.totalAllocationReportGridData)) {
        if (value.currentInventory < value.AllocationReportPoint)
          totalAllocationReportItems.push(value);
        if (value.isActive === false)
          totalAllocationReportItems.push(value);
      }
      this.AllocationReportGridData = totalAllocationReportItems;
      this.loadAllocationReportHeaderGridData();
    }
    else if (this.isonlyAllocationReport) {
      let onlyAllocationReportItems: any[] = [];
      for (const [key, value] of Object.entries(this.totalAllocationReportGridData)) {
        if (value.currentInventory < value.AllocationReportPoint)
          onlyAllocationReportItems.push(value);
      }
      this.AllocationReportGridData = onlyAllocationReportItems;
      this.loadAllocationReportHeaderGridData();
    }
    else if (this.isInActiveAllocationReport) {
      const dataList = this.totalAllocationReportGridData.filter(r => r.isActive === false);
      this.AllocationReportGridData = dataList;
      this.loadAllocationReportHeaderGridData();
    }
    else {
      this.AllocationReportGridData = this.totalAllocationReportGridData;
      this.loadAllocationReportHeaderGridData();
    }
  }

  getAllAllocationReportReport() {
    this.AllocationReportLoading = true;

    this.productSampleFulfillmentService.getSampleAdminBudgetAllocationReport().subscribe((response: Array<any>) => {
      if (response) {
        this.totalAllocationReportGridData = response;
        this.AllocationReportGridData = response;
        //this.productSampleFulfillmentService.setAllocationReportHeaderGridData(this.AllocationReportGridData);
        this.loadAllocationReportHeaderGridData();
      }
    }, err => {
      this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while loading the page.');
    })
    this.AllocationReportLoading = false;
  }

  private loadAllocationReportHeaderGridData(): void {
    if (this.AllocationReportGridSettings.state)
      this.AllocationReportHeaderGridData = process(this.AllocationReportGridData, this.AllocationReportGridSettings.state);
    else
      this.AllocationReportHeaderGridData = process(this.AllocationReportGridData, this.AllocationReportGridstate);
    this.AllocationReportGridSettings.gridData = this.AllocationReportHeaderGridData;
  }
  protected AllocationReportHeaderGridSortChange(sort): void {
    this.AllocationReportGridstate.sort = sort;
    this.loadAllocationReportHeaderGridData();
  }

  protected AllocationReportHeaderGridPageChange({ skip, take }: PageChangeEvent): void {
    this.AllocationReportGridstate.skip = skip;
    this.AllocationReportGridstate.take;
    this.loadAllocationReportHeaderGridData();
  }

  public AllocationReportHeaderGridDataStateChange(state: DataStateChangeEvent): void {
    this.AllocationReportGridstate = state;
    this.AllocationReportGridSettings.state = this.AllocationReportGridstate;
    this.loadAllocationReportHeaderGridData();
  }
  generateExcel() {
    this.loadingExcel = true;
    var currFilter = this.AllocationReportGridSettings.state.filter;
    var filterData = process(this.AllocationReportGridData, {
      filter: currFilter
    });
    let workbook: ExcelProper.Workbook = new Excel.Workbook();
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    this.AllocationReportGridSettings.columnsConfig.filter(c => c.hidden != true).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    let worksheet = workbook.addWorksheet();
    const header = [this.AllocationReportLblText.regcodelbl,
    this.AllocationReportLblText.regdesclbl,
    this.AllocationReportLblText.budgetcodelbl];

    worksheet.addRow([]);
    worksheet.addRow([]);

    let orderDetailsRow = worksheet.addRow([this.AllocationReportLblText.sampleProductLbl]);
    orderDetailsRow.font = { size: 10, underline: 'double', bold: true };
    //Add Header row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    dataArray.map(p =>
    ([
      p.regionCode ? p.regionCode : '',
      p.regionDescription ? p.regionDescription : '',
      p.budgetCode ? p.budgetCode : '',
    ])
    )
      .forEach(d => {
        let row = worksheet.addRow(d);
      });
    worksheet.addRow([]);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'SampleRequestAllocationReport.xlsx');
    })
    this.loadingExcel = false;
  }

  async generatePDF() {
    //debugger;
    this.loadingPDF = true;
    var currFilter = this.AllocationReportGridSettings.state.filter;
    var filterData = process(this.AllocationReportGridData, {
      filter: currFilter
    });
    //#region - format data based on column settings
    var titleOutput = [];
    var fieldOutput = [];
    var widthOutput = [];
    this.AllocationReportGridSettings.columnsConfig.filter(c => c.hidden != true && c.widthForPDF > 0).forEach(c => {
      titleOutput.push(c.title);
      fieldOutput.push(c.field);
      widthOutput.push(c.widthForPDF);
    });
    //debugger;
    var dataArray: any[] = [];
    filterData.data.forEach(d => {
      dataArray.push(_.pick(d, fieldOutput));
    });
    //#endregion
    var todaysDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    let docDefinition = {
      header: {
        columns: [
          { text: todaysDate, margin: [10, 12, 10, 20] },
          { text: this.AllocationReportLblText.sampleProductLbl, alignment: 'center', margin: [10, 12, 0, 20] }
        ]
      },
      content: [
        {
          // under NodeJS (or in case you use virtual file system provided by pdfmake)
          // you can also pass file names here
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          text: "Sample Request Budget List",
          style: 'sectionHeader'
        },
        {
          style: 'tableStyle',
          table: {
            headerRows: 1,
            //widths: ['*'],
            widths: widthOutput,
            body: [
              [
                this.AllocationReportLblText.regcodelbl,
                this.AllocationReportLblText.regdesclbl,
                this.AllocationReportLblText.budgetcodelbl
              ],
              ...filterData.data.map(p =>
              ([
                p.regionCode,
                p.regionDescription,
                p.budgetCode
              ])
              )
            ]
          }
        }
      ],
      footer: {
        columns: [
          { text: '©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        headerLeft: {
          fontSize: 22,
        },
        headerRight: {
          fontSize: 22,
          alignment: 'center'
        },
        anotherStyle: {
          italics: true,
          alignment: 'right'
        },
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        tableStyle: {
          fontSize: 8
        }
      }
    };

    pdfMake.createPdf(docDefinition).download('SampleRequestAllocationReport.pdf');
    this.loadingPDF = false;
  }

  async AddNewAllocationPopUp() {
    this.IsAddNewAllocation = true;
    this.isEditOn = false; 
  }
  async validateAllocationForm() {
    debugger;
    this.addNewAllocationV.regionCode = this.AllocationForm.controls.regCode.value;
    this.addNewAllocationV.regionDescription = this.AllocationForm.controls.regDesc.value;
    this.addNewAllocationV.budgetCode = this.AllocationForm.controls.budgetCode.value;
    if (this.addNewAllocationV.regionDescription == '' || this.addNewAllocationV.regionCode == '' || this.addNewAllocationV.budgetCode == '') {
      return false;
    }
  }

  async AddNewAllocation() {
    this.isNewLocationComplete = false;
    this.addNewAllocationV.regionCode = this.AllocationForm.controls.regCode.value;
    this.addNewAllocationV.regionDescription = this.AllocationForm.controls.regDesc.value;
    this.addNewAllocationV.budgetCode = this.AllocationForm.controls.budgetCode.value;
    if (this.addNewAllocationV.regionDescription == '' || this.addNewAllocationV.regionCode == '' || this.addNewAllocationV.budgetCode == '') {
      return false;
    } else {
      this.productSampleFulfillmentService.AddSampleBudgetAssociation(this.addNewAllocationV).subscribe((response: Array<any>) => {
        if (response) {
          this.isNewLocationComplete = true;
          this.isNewLocationSuccess = true;
          if (!this.isEditOn) {
            this.AllocationReportLblText.addNewLocationResponse = 'New allocation created successfully';
          } else {
            this.AllocationReportLblText.addNewLocationResponse = 'Allocation updated successfully';
          }
          this.AllocationForm.reset();
          // new Promise(f => setTimeout(f, 2000));
          this.getAllAllocationReportReport();
        }
      }, err => {
        this.isNewLocationComplete = true;
        this.isNewLocationSuccess = false;
        this.appNotifyService.notify(NotifyType.ERROR, 'Sorry an error occured while new allocation creation.');
        this.AllocationForm.reset();
        if (!this.isEditOn) {
          this.AllocationReportLblText.addNewLocationResponse = 'Sorry an error occured while new allocation creation.';
        } else {
          this.AllocationReportLblText.addNewLocationResponse = 'Sorry an error occured while allocation updation.';
        }
        })
    }
  }
  public close(): void {
    this.IsAddNewAllocation = !this.IsAddNewAllocation;
    this.AllocationReportLblText.addNewLocationResponse = '';
    this.AllocationForm.reset();
  }
  public editAllocation(dataItem: ISampleAdminBudgetAllocation) {
    this.IsAddNewAllocation = true;
    this.isEditOn = true;
    this.addNewAllocationV.regionCode = dataItem.regionCode;
    this.addNewAllocationV.regionDescription = dataItem.regionDescription;
    this.addNewAllocationV.budgetCode = dataItem.budgetCode;
    this.AllocationForm.controls.regCode.setValue(dataItem.regionCode);
    this.AllocationForm.controls.regDesc.setValue(dataItem.regionDescription);
    this.AllocationForm.controls.budgetCode.setValue(dataItem.budgetCode);
  }
  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  public isEditOn: boolean = false;
  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete allocation ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  protected confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  protected RemoveHandler() {
    this.productSampleFulfillmentService.DeleteSampleBudgetAssociation(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const subCategoryId = this.gridItemToRemove.subCategoryId;
      //const sku = this.gridItemToRemove.sku;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected allocation has been removed.");

      if (this.productSampleFulfillmentService.sampleSubCategory) {
        //This is a Local Remove
       // const index = (this.productSampleFulfillmentService.sampleSubCategory).findIndex(r => r.subCategoryId === subCategoryId);
        //(this.productSampleFulfillmentService.sampleSubCategory).splice(index, 1);
       // this.bindFinishSampleGrid();

      }

    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }
  async redirectToBudgetAllocationPage() {
    this.router.navigate(['sample-request-admin/admin-budget-report']);
  }
  async redirectToInventoryUsagePage() {
    this.router.navigate(['sample-request-admin/sample-request-inventory-usage-report']);
  }
  async redirectToOrderHistoryPage() {
    this.router.navigate(['sample-request-admin/sample-request-order-history']);
  }
  async changepasswordredirect() {
    this.router.navigate(['change-password']);
  }
  //#endregion
}

